module.exports = __webpack_public_path__ + "img/banner2.d5bc306.jpg";